
const development = {
    baseURL: "https://fb1-authors-api.mypat.in",
    watsonURL: "https://fb1-watson.mypat.in",
    stakeholderURL: "https://fb1-v4-teachers.mypat.in/",
    glorifireURL: "https://fb1-v4.mypat.in/",
    stakeholderAPIurl: "https://fb1-teachers-auth-service.mypat.in/",
    localStorageKey: "patmy",
    awsBucketUrl: "https://mypat-successive-video.s3.amazonaws.com/",
    thumbnailBucketUrl: "https://s3.us-east-2.amazonaws.com/mypat-cms-content-staging",
    challengeQuestionBucketUrl: "https://mypat-cms-content-staging.s3.us-east-2.amazonaws.com/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'V5ebyiwdj0kjhUKkCrCj'
}

const feature1 = {
    baseURL: "http://fb1-authors-api.mypat.in",
    watsonURL: "http://fb1-watson.mypat.in",
    stakeholderURL: "https://fb1-v4-teachers.mypat.in/",
    glorifireURL: "https://fb1-v4.mypat.in/",
    stakeholderAPIurl: "https://fb1-teachers-auth-service.mypat.in/",
    localStorageKey: "patmy",
    thumbnailBucketUrl: "https://s3.us-east-2.amazonaws.com/mypat-cms-content-staging",
    challengeQuestionBucketUrl: "https://mypat-cms-content-staging.s3.us-east-2.amazonaws.com/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'V5ebyiwdj0kjhUKkCrCj'
}

const feature2 = {
    baseURL: "http://fb2-authors-api.mypat.in",
    watsonURL: "http://fb2-watson.mypat.in",
    stakeholderURL: "https://fb2-v4-teachers.mypat.in/",
    localStorageKey: "patmy",
    glorifireURL: "https://fb1-v4.mypat.in/",
    thumbnailBucketUrl: "https://s3.us-east-2.amazonaws.com/mypat-cms-content-staging",
    challengeQuestionBucketUrl: "https://mypat-cms-content-staging.s3.us-east-2.amazonaws.com/",
    stakeholderAPIurl: "https://fb2-teachers-auth-service.mypat.in/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'NZ3PB7nllsLsLa5C95Gw'
}

const feature3 = {
    baseURL: "http://fb3-authors-api.mypat.in",
    watsonURL: "http://fb3-watson.mypat.in",
    stakeholderURL: "https://fb3-v4-teachers.mypat.in/",
    glorifireURL: "https://fb1-v4.mypat.in/",
    localStorageKey: "patmy",
    thumbnailBucketUrl: "https://s3.us-east-2.amazonaws.com/mypat-cms-content-staging",
    challengeQuestionBucketUrl: "https://mypat-cms-content-staging.s3.us-east-2.amazonaws.com/",
    stakeholderAPIurl: "https://fb3-teachers-auth-service.mypat.in/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'NZ3PB7nllsLsLa5C95Gw'
}


const staging = {
    baseURL: "http://staging-authors-api.mypat.in",
    watsonURL: "http://watson-staging.mypat.in",
    stakeholderURL: "https://staging-v4-teachers.mypat.in/",
    glorifireURL: "https://staging.glorifire.com/",
    localStorageKey: "patmy",
    thumbnailBucketUrl: "https://s3.us-east-2.amazonaws.com/mypat-cms-content-staging",
    challengeQuestionBucketUrl: "https://mypat-cms-content-staging.s3.us-east-2.amazonaws.com/",
    stakeholderAPIurl: "https://staging-v4-auth-service.mypat.in/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'NZ3PB7nllsLsLa5C95Gw'
    //JoditImageUploaderPath: 'http://fb1-jodit-image-uploader.mypat.in/',
    //baseURL: "http://192.168.2.91:3026/",
    // JoditImageUploaderPath: 'http://staging-jodit-image-uploader.mypat.in/',
    // mathEditorJs: 'https://math-html-editor-dev.s3.ap-south-1.amazonaws.com/js',
    // mathEditorCss: 'https://math-html-editor-dev.s3.ap-south-1.amazonaws.com/css',
}

const production = {
    baseURL: "https://v2cms2-prod.mypat.in",
    watsonURL: "https://ops.glorifire.com",
    stakeholderURL: "https://stakeholder.glorifire.com/",
    glorifireURL: "https://glorifire.com/",
    localStorageKey: "patmy",
    thumbnailBucketUrl: "https://s3.us-west-2.amazonaws.com/mypat-cms-content-prod",
    challengeQuestionBucketUrl: "https://s3.us-west-2.amazonaws.com/mypat-cms-vid-content-dev/",
    stakeholderAPIurl: "https://teachers-auth-service.mypat.in/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'V5ebyiwdj0kjhUKkCrCj'
    //JoditImageUploaderPath: 'http://fb1-jodit-image-uploader.mypat.in/',
    //baseURL: "http://192.168.2.91:3026/",
    // JoditImageUploaderPath: 'https://prodtest-jodit.mypat.in/',
    // mathEditorJs: 'https://math-html-editor.s3.ap-south-1.amazonaws.com/js',
    // mathEditorCss: 'https://math-html-editor.s3.ap-south-1.amazonaws.com/css', 
}


const uat = {
    baseURL: "https://uat-authors-api.mypat.in", 
    watsonURL: "https://beta-ops.glorifire.com",
    stakeholderURL: "https://uat-v4-teachers.mypat.in/",
    glorifireURL: "https://uat-v4.mypat.in/",
    JoditImageUploaderPath: 'http://fb1-jodit-image-uploader.mypat.in/',
    mathEditorJs: 'https://math-html-editor-dev.s3.ap-south-1.amazonaws.com/js',
    mathEditorCss: 'https://math-html-editor-dev.s3.ap-south-1.amazonaws.com/css',
    localStorageKey: "patmy",
    stakeholderAPIurl: "https://uat-teachers-auth-service.mypat.in/",
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'V5ebyiwdj0kjhUKkCrCj'
}

const beta = {
    baseURL: 'https://uat-authors-api.mypat.in',
    watsonURL: 'https://beta-ops.glorifire.com',
    stakeholderURL: 'https://beta-stakeholder.glorifire.com/',
    glorifireURL: "https://beta.glorifire.com/",
    JoditImageUploaderPath: 'http://fb1-jodit-image-uploader.mypat.in/',
    mathEditorJs: 'https://math-html-editor-dev.s3.ap-south-1.amazonaws.com/js',
    mathEditorCss: 'https://math-html-editor-dev.s3.ap-south-1.amazonaws.com/css',
    localStorageKey: 'patmy',
    stakeholderAPIurl: 'https://uat-teachers-auth-service.mypat.in/',
    captchaKey: '6LdURVEUAAAAADSnZK0cJacinv-PqlTO_7K-CQkU',
    fingerprintJsKey: 'V5ebyiwdj0kjhUKkCrCj',
}

const config: any = {
    development,
    feature1,
    feature2,
    feature3,
    staging,
    production,
    uat,
    beta,
}

// default config
let configBasedOnEnv = {
    ...config['development']
}

//config based on ENV
if (process.env.REACT_APP_ACTIVE_ENV && config[process.env.REACT_APP_ACTIVE_ENV]) {
    configBasedOnEnv = config[process.env.REACT_APP_ACTIVE_ENV];
}
export default configBasedOnEnv;
